import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import {
  Avatar,
  Grid,
  Paper,
  Modal,
  Typography,
  TextField,
  Container,
  Button,
  FormControlLabel,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Select,
  MenuItem,
} from "@material-ui/core";
import { useUserContext } from "../../../../context/UserContext";
import api from "../../../../Axios/api";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import EditIcon from "@material-ui/icons/Edit";
import ImgNotAvailable from "../../../../assets/images/imgNotAvailable.jpg";
import ImageCropProfile from "../../../FormDialog/ImageCropProfile";
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto";
import RemoveProfilePic from "../../../FormDialog/RemoveProfilePic";
import useStyles from "./styles";
import Pal from "../../../../themes/palette";

export default function ViewBuyers() {
  const classes = useStyles();
  // context
  const { store } = useUserContext();
  const token = store.data.token;

  ///////////////////////////Buyer Details Start/////////////////////////////////////////////////////
  const [buyerDetails, setBuyerDetails] = useState({
    name: "",
    email: "",
    gender: "",
    birthday: "",
    phoneNumber: "",
    storeName: "",
    profilePic: "",
    isAccountActive: false,
  });

  const handleBuyerDetails = (input) => (e) => {
    setBuyerDetails({ ...buyerDetails, [input]: e.target.value });
  };

  ////////////////////Swicth Button End ////////////////////////////////////////////////////////

  /////////////// Snackbar///////////////////////////////////////////////////////////////////
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };

  ///////////////Snack Bar ///////////////////////////////////////////////////////////////////

  const editBuyerHandler = (e) => {
    console.log(buyerDetails);
    e.preventDefault();

    const { name, email, phoneNumber, birthday, gender, profilePic } =
      buyerDetails;

    api
      .patch(
        `/superAdmin/buyer/${buyerDetails._id}`,
        {
          name,
          email,
          phoneNumber,
          birthday,
          gender,
          profilePic,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        try {
          const newDetails = details.map((prod) =>
            prod._id === buyerDetails._id ? buyerDetails : prod
          );
          setDetails(newDetails);
          handleClose();
          setSnackBar({
            ...snackBarstate,
            type: "success",
            message: "SUCCESS: Buyer Info has been Updated!",
            open: true,
          });
        } catch (error) {}
      })
      .catch((error) => {
        handleClose();
        setSnackBar({
          ...snackBarstate,
          message:
            "ERROR: " + JSON.stringify(error.response.data.error.message),
          type: "error",
          open: true,
        });
      });
  };

  // Modal Settings here
  const [modalOpenn, setModelOpenn] = useState(false);

  const handleOpenn = () => {
    setModelOpenn(true);
  };

  const handleClosen = () => {
    setModelOpenn(false);
  };

  ////////////////image upload settings start//////////////////////////////////
  const [isProfilePicRemove, setIsProfilePicRemove] = useState(false);
  const onSelectlogo = (image) => {
    setBuyerDetails({ ...buyerDetails, profilePic: image });
  };
  const handleChange = (input) => (e) => {
    setBuyerDetails({ ...buyerDetails, [input]: e.target.value });
  };

  // Show delete ProfilePic dialog
  const handlerRemoveProfilePic = (e) => {
    e.preventDefault();
    setIsProfilePicRemove(true);
  };

  const confirmedRemoveProfilePic = () => {
    setBuyerDetails({ ...buyerDetails, profilePic: null });
    setIsProfilePicRemove(false);
  };
  ////////////////image upload settings end //////////////////////////////////

  // Edit Product Modal Settings here
  const [modalOpen, setModelOpen] = useState(false);
  const handleOpen = () => {
    setModelOpen(true);
  };
  const handleClose = () => {
    setModelOpen(false);
  };

  const handerChangeStatus = (id) => async (e) => {
    let newStatus = e.target.value;
    const newComplaintsList = details.map((el) =>
      el._id === id ? { ...el, isAccountBlocked: newStatus === "true" } : el
    );

    console.log(newComplaintsList);

    await api
      .patch(
        `/superAdmin/buyer/${id}`,
        { isAccountBlocked: newStatus },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(() => {
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "SUCCESS: Status has been Changed!",
          open: true,
        });
        setDetails(newComplaintsList);
      })
      .catch((error) => {
        setSnackBar({
          ...snackBarstate,
          type: "error",
          message: "ERROR: Something went Wrong!",
          open: true,
        });
      });
  };

  const getAllBuyers = async () => {
    await api
      .get("/superAdmin/buyers", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        console.log("details are ", res.data.data.Buyers);
        setDetails(res.data.data.Buyers);
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  };

  /////////////////Ending /////////////////////////////////////////////////////////////////////

  const [details, setDetails] = useState();

  const columns = [
    {
      title: "ID",
      field: "tableData.id",
      render: ({ tableData }) => <div>{tableData.id + 1}</div>,
      hidden: false,
      export: false,
    },
    {
      title: "Image",
      field: "profilePic",
      render: ({ profilePic }) => (
        <img
          src={profilePic != null ? profilePic : ImgNotAvailable}
          alt="Profile Pic"
          style={{ width: 40, height: 40, borderRadius: "50%" }}
        />
      ),
    },
    {
      title: "Name",
      field: "name",
      width: 150,
    },
    {
      title: "Email",
      field: "email",
      width: 150,
    },
    {
      title: "Contact",
      field: "phoneNumber",
      width: 150,
    },
    { title: "Gender", field: "gender", width: "0%" },
    {
      title: "Status",
      field: "isAccountBlocked",
      align: "center",
      render: ({ isAccountBlocked }) => (
        <div
          style={{
            height: 30,
            width: 100,
            display: "flex",
            justifyContent: "right",
            alignItems: "center",
            background:
              isAccountBlocked === true
                ? "rgba(231, 76, 60, 0.7)"
                : "rgba(112, 224, 0, 0.7)",

            color: "#262626",
            borderRadius: 4,
          }}
        >
          <div
            style={{
              background:
                isAccountBlocked === true
                  ? "rgba(231, 76, 60, 0.7)"
                  : "rgba(112, 224, 0, 0.7)",

              width: 15,
              height: 15,
              borderRadius: 8,
              marginRight: 5,
              marginLeft: 5,
            }}
          ></div>
          {isAccountBlocked === true ? "Blocked" : "Active"}
        </div>
      ),
    },
    {
      field: "",
      title: "Actions",
      align: "center",
      render: (rowData) => (
        <div>
          <Select
            id="status"
            style={{ marginTop: 8 }}
            defaultValue={"DEFAULT"}
            onChange={handerChangeStatus(rowData._id)}
          >
            <MenuItem value="DEFAULT" disabled>
              Status
            </MenuItem>
            <MenuItem value="true">Block</MenuItem>
            <MenuItem value="false">Activate</MenuItem>
          </Select>
        </div>
      ),
      export: false,
    },
  ];

  useEffect(() => {
    // fetching List of Buyers from API
    getAllBuyers();
  }, []);

  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} sm={12} md={12} component={Paper}>
        <MaterialTable
          title="All Buyers of Digi-Mart"
          data={details}
          columns={columns}
          actions={[
            (rowData) => ({
              icon: () => <EditIcon />,
              tooltip: "Edit",
              onClick: (event, rowData) => {
                setBuyerDetails(rowData);
                handleOpen();
              },
            }),
          ]}
          options={{
            actionsColumnIndex: -1,
            headerStyle: {
              backgroundColor: Pal.palette.primary.main,
              color: "#fff",
              whiteSpace: "nowrap",
            },
            exportButton: true,
            tableLayout: "auto",
          }}
        />
        <Snackbar
          open={open}
          anchorOrigin={{ vertical, horizontal }}
          autoHideDuration={3000}
          onClose={handleCloseSnackBar}
          key={vertical + horizontal}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            onClose={handleCloseSnackBar}
            severity={snackBarstate.type}
          >
            {snackBarstate.message}
          </MuiAlert>
        </Snackbar>
      </Grid>
      {/* //////////////////////////////////////////////////Edit Buyer///////////////////////////////////////// */}
      <Modal
        open={modalOpen}
        onClose={handleClose}
        onBackdropClick={handleClose}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Container component={Paper} maxWidth="md" style={{ padding: 20 }}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={12} align="center">
              <Typography variant="h5">Edit Buyer</Typography>
            </Grid>
            <form className={classes.form} noValidate style={{ padding: 20 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <TextField
                    autoFocus
                    margin="dense"
                    variant="outlined"
                    autoComplete="fName"
                    required
                    fullWidth
                    label="Full Name"
                    name="fname"
                    value={buyerDetails.name}
                    onChange={handleBuyerDetails("name")}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    label="Email"
                    id="email"
                    name="email"
                    value={buyerDetails.email}
                    onChange={handleBuyerDetails("email")}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    placeholder="Enter Contact"
                    label="Contact Number"
                    name="contact number"
                    value={buyerDetails.phoneNumber}
                    onChange={handleBuyerDetails("phoneNumber")}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {" "}
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    placeholder="dd/MM/YYYY"
                    label="Date Of Birth"
                    name="dob"
                    value={buyerDetails.birthday}
                    onChange={handleBuyerDetails("birthday")}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">Gender</FormLabel>
                    <RadioGroup
                      row
                      aria-label="gender"
                      name="gender1"
                      value={buyerDetails.gender}
                      onChange={handleBuyerDetails("gender")}
                    >
                      <FormControlLabel
                        value="female"
                        control={<Radio />}
                        label="Female"
                      />
                      <FormControlLabel
                        value="male"
                        control={<Radio />}
                        label="Male"
                      />

                      <FormControlLabel
                        value="other"
                        control={<Radio />}
                        label="Other"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}></Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={6}></Grid>
              </Grid>

              {/*///////////////////////// image upload option /////////////////////////////*/}
              {/*///////////////////////// image upload option /////////////////////////////*/}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  marginBottom: "20px",
                }}
              >
                <Avatar
                  alt="profile photo"
                  src={buyerDetails.profilePic}
                  className={classes.avatarInProfileSetting}
                >
                  {"Pic HERE"}
                </Avatar>
                <div style={{ marginTop: 50 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleOpenn}
                  >
                    <AddAPhotoIcon
                      style={{
                        marginRight: 5,
                        fontSize: 22,
                        marginBottom: 5,
                      }}
                    />
                    Upload
                  </Button>
                  <Button
                    onClick={handlerRemoveProfilePic}
                    style={{ color: "red" }}
                    color="red"
                  >
                    Remove Image
                  </Button>
                </div>
              </div>

              <Grid item xs={12} sm={12} md={12} align="right">
                <Button
                  variant="outlined"
                  color="primary"
                  style={{ marginRight: 10 }}
                  onClick={handleClose}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={editBuyerHandler}
                >
                  Save Changes
                </Button>
                <RemoveProfilePic
                  RemoveProfilePic={isProfilePicRemove}
                  setRemoveProfilePic={setIsProfilePicRemove}
                  confirmedRemoveProfilePic={confirmedRemoveProfilePic}
                />
              </Grid>
            </form>
          </Grid>
        </Container>
      </Modal>

      <Modal
        open={modalOpenn}
        onClose={handleClosen}
        onBackdropClick={handleClosen}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "#FFF",
            width: "70vw",
            height: "70vh",
            padding: "20px",
            position: "relative",
          }}
        >
          <ImageCropProfile
            onProfileChange={onSelectlogo}
            handleClose={handleClosen}
          />
        </div>
      </Modal>
    </Grid>
  );
}
